import * as PROPS from '../enums/props';

export const localOptions = {
    [PROPS.DATA]: {
        value: null
    }
};
